import {
  loadTranslationEngineJson,
  selectionConverterTranslationLanguages,
  type TranslationLanguageEntry,
} from '@core/translation/languageTables.ts';
import { shouldLoadTranslationLanguageOptions } from '@core/translation/subtitleTrackGate.ts';
import type { TrackList } from '@core/model/track.ts';
import googleJson from '../../../extension/src/adapters/resource/json/google.json';
import azureJson from '../../../extension/src/adapters/resource/json/azure.json';
import deeplJson from '../../../extension/src/adapters/resource/json/deepl.json';

type EngineTranslationJson = {
  translation: Record<string, { nativeName: string }>;
};

const googleCodes: TranslationLanguageEntry[] = [];
const azureCodes: TranslationLanguageEntry[] = [];
const deeplCodes: TranslationLanguageEntry[] = [];

let loaded = false;

function ensureEngineTables(): void {
  if (loaded) return;
  loadTranslationEngineJson(googleJson as EngineTranslationJson, googleCodes);
  loadTranslationEngineJson(azureJson as EngineTranslationJson, azureCodes);
  loadTranslationEngineJson(deeplJson as EngineTranslationJson, deeplCodes);
  loaded = true;
}

/** Extension `startTranslationEngineController` engine → language table. */
export function translationEntriesForEngine(engine: string | undefined): TranslationLanguageEntry[] {
  ensureEngineTables();
  switch (engine) {
    case 'deepl':
      return deeplCodes;
    case 'azure':
    case 'ai':
    case 'batch':
      return azureCodes;
    case 'google':
    default:
      return googleCodes;
  }
}

/**
 * Extension popup translation options: only when subtitle tracks exist;
 * otherwise return [] (and clear selections).
 */
export function translationsForEngine(
  engine: string | undefined,
  subtitles: TrackList['subtitles'] | unknown,
): TrackList['translations'] {
  if (!shouldLoadTranslationLanguageOptions(subtitles)) return [];
  return selectionConverterTranslationLanguages(translationEntriesForEngine(engine));
}
